import { FeeModalities } from '@tokeet/cost-resolver'

export const FeeModalityLabels: { [key: string]: string } = {
  [FeeModalities.PerPerson]: $localize`Per Person`,
  [FeeModalities.PerNight]: $localize`Per Night`,
  [FeeModalities.PerPersonPerNight]: $localize`Per Person/Per Night (PP/PN)`,
  [FeeModalities.PerStay]: $localize`Per Stay`,
}
